import * as THREE from 'three';
import { DEFAULT_DIVIDERS, dividerLines } from './dividerLayout';

export function dividerArray(group, count, panelWidth, height, input, frame, dimensions = {}) {
  const bars = { ...DEFAULT_DIVIDERS, ...input }, lines = dividerLines(bars);
  group.userData.dividers = bars;
  if (!lines.length) return () => {};
  const width = dimensions.glassWidth ?? panelWidth - .152, glassHeight = dimensions.glassHeight ?? height - .236, centerY = dimensions.glassCenterY ?? height / 2, bar = bars.bar_width_in * .0254;
  // Decorative bars live between the two glazing sheets and share frame finish.
  const mesh = new THREE.InstancedMesh(new THREE.BoxGeometry(1, 1, 1), frame, count * lines.length);
  mesh.name = 'glass-lite-dividers'; mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage); mesh.receiveShadow = true; group.add(mesh);
  const transform = new THREE.Object3D();
  return positions => {
    positions.forEach((position, panel) => lines.forEach((line, index) => {
      transform.position.set(position.x + ((line.x1 + line.x2) / 2 - .5) * width, centerY + ((line.y1 + line.y2) / 2 - .5) * glassHeight, position.z);
      transform.scale.set(line.x1 === line.x2 ? bar : width * (line.x2 - line.x1), line.y1 === line.y2 ? bar : glassHeight * (line.y2 - line.y1), .012);
      transform.updateMatrix(); mesh.setMatrixAt(panel * lines.length + index, transform.matrix);
    }));
    mesh.instanceMatrix.needsUpdate = true; mesh.computeBoundingSphere(); mesh.computeBoundingBox();
  };
}